import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSnackBar} from '@angular/material';
import {AccessoryRequestReasonName} from '../../models/AccessoryRequestReasonName';

@Component({
  selector: 'app-accessory-request-reasons',
  styleUrls: ['./accessory-request-reasons.component.scss'],
  templateUrl: './accessory-request-reasons.component.html'
})
export class AccessoryRequestReasonsComponent implements OnInit {
  public editedReasonName: string;
  public reasonDataSource: MatTableDataSource<AccessoryRequestReasonName>;
  public reasonNameColumns: string[] = ['name', 'actions'];
  public isReasonEditable: boolean;
  public loading: boolean;
  public newName: string;
  private updateReasonItem: any;

  constructor(private commonService: CommonService,
              private matSnackBar: MatSnackBar) {
    this.isReasonEditable = false;
    this.loading = false;
  }

  async ngOnInit(): Promise<void> {
    await this.getReasonNames();
  }

  async addReasonName() {
    if (this.newName) {
      try {
        const result = await this.commonService.insertObject('accessory/request_reason', {name: this.newName});
        this.toastMessages('Η αιτία δημιουργήθηκε με επιτυχία');
        const model = {
          id: result.id,
          name: this.newName,
          has_been_used: 0
        };
        const data = JSON.parse(JSON.stringify(this.reasonDataSource.data));
        data.push(model);
        this.reasonDataSource.data = data;
        this.resetReasonName();
        this.toastMessages(`Η αιτία δημιουργήθηκε με επιτυχία`);
      } catch (e) {
        this.toastMessages(`Αποτυχία δημιουργίας. Λόγος: ${e.message}`);
      }
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενό');
    }
  }

  applyFilterReasonNames(value: any): void {
    this.reasonDataSource.filter = value.trim().toLocaleLowerCase();
  }

  async deleteReason(id: number, index: number) {
    try {
      await this.commonService.deleteRecord(`accessory/request_reason/${id}`);
      this.toastMessages('Η αιτία διαγράφηκε με επιτυχία');
      const data = JSON.parse(JSON.stringify(this.reasonDataSource.data));
      data.splice(index, 1);
      this.reasonDataSource.data = data;
    } catch (e) {
    }
  }

  editReasonName(id: any, index: any): void {
    this.isReasonEditable = true;
    this.editedReasonName = this.reasonDataSource.data[index].name;
    this.updateReasonItem = {
      id,
      index,
      name: this.reasonDataSource.data[index].name
    };
  }

  async getReasonNames(): Promise<any> {
    try {
      this.loading = true;
      const data = await this.commonService.getSimpleList('accessory/request_reason') as AccessoryRequestReasonName[];
      this.reasonDataSource = new MatTableDataSource<AccessoryRequestReasonName>(data);
    } catch (e) {
      throw e;
    } finally {
      this.loading = false;
    }
  }

  isDeleteReasonDisabled(element: any): boolean {
    return element.has_been_used !== 0;
  }

  async updateReasonName() {
    const data = JSON.parse(JSON.stringify(this.reasonDataSource.data));
    const updatedItem = data.find(item => item.id === this.updateReasonItem.id);

    const model = {
      id: this.updateReasonItem.id,
      name: this.editedReasonName,
      has_been_used: updatedItem.has_been_used
    };

    if (this.editedReasonName) {
      try {
        await this.commonService.updateObject(`accessory/request_reason/${model.id}`, {name: this.editedReasonName});
        this.toastMessages('Η ενημέρωση ολοκληρώθηκε με επιτυχία');
      } catch (e) {
        this.toastMessages(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
      }

      const index = this.updateReasonItem.index;
      data[index] = model;
      this.reasonDataSource.data = data;

      this.resetReasonName();
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενο');
    }
  }

  resetReasonName(): void {
    this.newName = '';
    this.updateReasonItem = {};
    this.isReasonEditable = false;
    this.editedReasonName = '';
  }

  toastMessages(message: string): void {
    this.matSnackBar.open(message, '', {
      duration: 5000,
    });
  }
}
